import { apiGetToken, apiGetUser } from '@/modules/User/services/authentication'
import { USER_MODULE_NAME, USER_SET_ROLE } from '@/modules/User/store/types'

import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_FORMID,
  WARRANTY_UPDATE_SINID
} from '@/store/types'
import { apiGetSendOtp } from '../services/authentication'
import userModule from '@/modules/User/store'
import { mapActions } from 'vuex'

/**
 * @module
 * @name authRoutersBuilder
 * @description Mixin which contains utils used for login purposes.
 */
export default {
  /**
   * @property {String} user.username Username.
   * @property {String} user.password Password.
   */
  data: function() {
    return {
      user: {
        username: '',
        password: ''
      }
    }
  },

  methods: {
    ...mapActions(USER_MODULE_NAME, {
      actUserSetRole: USER_SET_ROLE
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      updateWarrantyId: WARRANTY_UPDATE_FORMID,
      updateSinisterId: WARRANTY_UPDATE_SINID
    }),

    async getUserToken() {
      try {
        const userToken = await apiGetToken()
        if ('token' in userToken) {
          localStorage.setItem('mavAuth', `Token ${userToken.token}`)
        }
        return userToken
      } catch (e) {
        throw new Error(e)
      }
    },

    async getUserData() {
      try {
        const userData = await apiGetUser()
        if (userData.role) this.actUserSetRole(userData.role)
      } catch (e) {
        throw new Error(e)
      }
    },

    /**
     * * Authenticate throw backend API.
     * * Manage response, notifications.
     * * Use localStorage for sagving session information.
     * * Manage routes, parse information got from backend and add it to VueRouter.
     * @function
     * @name sendLogin
     */
    async sendLogin() {
      this.user.username = this.$route.params.user
      const userToken = await this.getUserToken()
      if (userToken) await this.getUserData()
    },

    async getOtpStatus() {
      try {
        const encSinisterId = this.$route.query.sinisterId
        const data = await apiGetSendOtp(encSinisterId)
        sessionStorage.setItem('sinId', data.sinisterId)
        sessionStorage.setItem('formId', data.formId)
        sessionStorage.setItem('telephone', data.telephone)

        this.updateWarrantyId(data.formId)
        this.updateSinisterId(data.sinisterId)
      } catch (e) {
        throw new Error(e)
      }
    }
  },
  /**
   * @function
   * @name beforeCreate
   * @description Registers the user module if it's not registered
   */
  beforeCreate: function() {
    if (!(USER_MODULE_NAME in this.$store.state)) {
      this.$store.registerModule(USER_MODULE_NAME, userModule)
    }
  }
}
